<template>
  <div v-if="show">
    <tableSearch @search="search = $event" :placeholder="$t('SEARCH_FOR', { type: $t('HARDWARE_TITLE') })" />

    <el-table :empty-text="$t('NO_DATA')" row-class-name="notSticky" :data="
      updatingTable.results.filter(
        (data) =>
          !search ||
          (data.device && data.device.imei.includes(toEnglish(search)))
      )
    " v-loading="updatingLoading" :stripe="true" style="width: 100%">
      <el-table-column sortable type="index" :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('INDEX')"
        width="60">
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('IMEI')" width="190">
        <template slot-scope="scope">
          <div :data-title="$t('IMEI')">
            <span v-if="scope.row.device">
              {{ scope.row.device.imei }}
            </span>
            <span v-else class="text-gray-400"> {{ $t("NO_HARDWARE") }} </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('STATUS')" width="140">
        <template slot-scope="scope">
          <div :data-title="$t('STATUS')">
            <div class="flex items-center">
              <span :style="`background-color:${scope.row.status == '1' ? 'green' : '#bf2610'
                }`" class="
                    rounded-xl
                    py-1
                    px-4
                    text-white text-xs text-center
                    shadow-md
                  ">
                {{
                  scope.row.status == "1" ? $t("ASSIGNED") : $t("UNASSIGNED")
                }}
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('TIME')" width="180">
        <template slot-scope="scope">
          <div :data-title="$t('TIME')">
            {{ new Date(scope.row.created).toLocaleTimeString("fa-IR") }} |
            {{ new Date(scope.row.created).toLocaleDateString("fa-IR") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('USERNAME')" width="180">
        <template slot-scope="scope">
          <div :data-title="$t('USERNAME')">
            {{ scope.row.user.username }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <Pagination parameter="and" :pagination="{
      count: updatingTable.count,
      current: +$route.query.p,
      request: `histories/company-vehicles/devices/?company_vehicle=${updatingTable.results.length > 0
          ? updatingTable.results[0].company_vehicle.id
          : ''
        }`,
    }" @tableData="updatingTable = $event" @loading="updatingLoading = $event" />
  </div>
</template>

<script>
import Pagination from "@/components/elements/pagination";
import tableSearch from "@/components/elements/tableSearch";
export default {
  props: ["tableData", "loading"],
  components: {
    tableSearch,
    Pagination,
  },
  data() {
    return {
      search: "",
      show: false,
      updatingTable: this.tableData,
      updatingLoading: this.loading,
    };
  },
  watch: {
    tableData(val) {
      this.show = true;
      this.updatingTable = val;
    },
  },
};
</script>
